import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine
} from 'recharts';

function TrendChart({
  utilityData,
  metricPath,
  selectedYear,
  label,
  unit = '',
  color = '#2563eb',
  lowerIsBetter = true
}) {
  // Extract metric from path like 'rates.residential_cents_kwh'
  const getNestedValue = (obj, path) => {
    const keys = path.split('.');
    let current = obj;
    for (const key of keys) {
      if (current === null || current === undefined) return null;
      current = current[key];
    }
    return current;
  };

  // Prepare data
  const years = Object.keys(utilityData.years || {}).sort();
  const data = years.map((year) => ({
    year,
    value: getNestedValue(utilityData.years[year], metricPath)
  })).filter(d => d.value !== null && d.value !== undefined);

  if (data.length === 0) {
    return (
      <div className="h-32 flex items-center justify-center text-gray-400 text-sm">
        No historical data available
      </div>
    );
  }

  // Calculate domain with padding
  const values = data.map(d => d.value);
  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);
  const padding = (maxVal - minVal) * 0.1 || 1;

  return (
    <div className="h-40 mt-2">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="year"
            tick={{ fontSize: 10, fill: '#6b7280' }}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 10, fill: '#6b7280' }}
            tickLine={false}
            domain={[minVal - padding, maxVal + padding]}
            tickFormatter={(val) => val.toFixed(1)}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
            formatter={(value) => [`${value.toFixed(2)}${unit}`, label]}
            labelFormatter={(label) => `Year: ${label}`}
          />
          {selectedYear && (
            <ReferenceLine
              x={selectedYear}
              stroke="#9ca3af"
              strokeDasharray="3 3"
              strokeWidth={1}
            />
          )}
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            dot={{ fill: color, r: 3 }}
            activeDot={{ r: 5, fill: color }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TrendChart;
